namespace TabAurous.ECommerce {
    export interface OrdersManagementForm {
    }

    export class OrdersManagementForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.OrdersManagement';
    }
}
